// PresetSidebar.styled.tsx or .styled.js
import styled from "styled-components";

import { device } from "utils/sizes";
import { colourScheme } from "utils/styling/colours";
import { SubTitle } from "utils/styling/typography.styled";

export const SidebarToggle = styled.div`
    position: absolute;
    top: 5rem;
    left: 1rem;
    height: 3rem;
    width: 3rem;
    svg,
    img {
        height: 100%;
        width: 100%;
    }
    cursor: pointer;
    z-index: 501;

    ${device.sm} {
        top: 6rem;
    }
`;

export const SidebarContainer = styled.div<{
    $active: boolean;
}>`
    display: ${({ $active }) => ($active ? "flex" : "none")};
    opacity: ${(props) => (props.$active ? 1 : 0)};
    top: 5rem;
    left: 0;
    bottom: 0;
    transition: all 0.2s;
    z-index: 500;
    background-color: ${colourScheme.primaryDark};
    flex-direction: column;
    gap: 0.5rem;
    align-items: center;
    width: 100%;
    position: fixed;
    height: calc(100%-10rem);
    padding: ${(props) => (props.$active ? "3rem 1rem 2rem" : "2rem 0")};

    ${device.sm} {
        width: ${(props) => (props.$active ? "20rem" : "0px")};
    }
`;

export const SidebarTitle = styled(SubTitle)`
    font-size: 1.5rem;
    text-align: center;
`;

export const PresetItemsContainer = styled.div`
    flex-grow: 1;
    overflow-y: auto;
    padding: 0.5rem;
    gap: 0.5rem;
    display: flex;
    flex-direction: column;
    width: 100%;
`;

export const PresetItem = styled.div`
    width: 100%;
    padding: 0.5rem 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    color: ${colourScheme.fullWhite};
    border-radius: 0.5rem;
    border: 2px solid rgba(255, 255, 255, 1);
    text-align: left;
    &:hover {
        background-color: ${colourScheme.primary};
    }
`;

export const DeleteIcon = styled.div`
    cursor: pointer;
    color: ${colourScheme.error};
    &:hover {
        transform: scale(1.1);
        transition: transform 0.2s ease-in-out;
    }
`;
